'use client';

import {
    A11Y_FILTER_DESCRIBED_BY,
    OUT_OF_STOCK_TEXT_KEY,
} from '../../SearchResultsFacets/constants';

import {
    StyledList,
    StyledListItem,
} from '@/components/SearchResultsFacets/styles';
import { checkRefinementApplied } from '@/components/SearchResultsFacets/utils';
import { getKeyValue } from '@/services/content/data';
import { SearchServiceProps } from '@/services/search/types';
import {
    FILTER,
    FILTER_REMOVE,
    FILTER_TYPE_LOCATION,
    FILTER_VAL,
    TRACK_TYPE_MULTI_ATTR,
} from '@/src/components/Analytics/constants';
import { FacetNormalized } from '@/src/components/SearchResultsFacets/types';
import useRefinement from '@/src/hooks/useRefinement';
import { Box } from '@mui/material';
import { Checkbox } from '@nxt-costco-com/forge-components';
import {
    Analytics,
    type ContentStackEntryDataProps,
    useQueryParams,
} from '@nxt-costco-com/forge-digital-components';

export function LocationFilterView({
    facet,
    facetConfig,
    searchService,
}: {
    facet: FacetNormalized;
    facetConfig: ContentStackEntryDataProps;
    searchService: SearchServiceProps;
}) {
    const { handleDoRefine } = useRefinement({ searchService, facetConfig });
    const { queryParams: searchParams } = useQueryParams();
    const label = getKeyValue(OUT_OF_STOCK_TEXT_KEY, facetConfig);

    return (
        <StyledList sx={{ marginTop: '15px' }}>
            {facet.buckets.map(bucket => {
                const isChecked = checkRefinementApplied({
                    facet,
                    bucket,
                    searchParams,
                    searchService,
                    facetConfig,
                });

                return (
                    <StyledListItem
                        key={bucket.val.toString()}
                        data-private={bucket.leads_to_fsa_chdi}
                        data-bi-private={bucket.leads_to_fsa_chdi}
                    >
                        <Box>
                            <Analytics
                                analyticData={{
                                    trackedData: [
                                        {
                                            key: isChecked
                                                ? FILTER_REMOVE
                                                : FILTER,
                                            value: FILTER_TYPE_LOCATION,
                                        },
                                        {
                                            key: FILTER_VAL,
                                            value: label,
                                        },
                                    ],
                                    trackType: TRACK_TYPE_MULTI_ATTR,
                                    doNotTrack: bucket.leads_to_fsa_chdi,
                                }}
                            >
                                <Checkbox
                                    ariaDescribeText={A11Y_FILTER_DESCRIBED_BY}
                                    onChange={event =>
                                        handleDoRefine(
                                            facet,
                                            bucket,
                                            event.target.checked,
                                        )
                                    }
                                    label={(<>{label}</>) as unknown as string}
                                    isChecked={!!isChecked}
                                    id={`${facet.facetKey}-${bucket.val?.toString()?.split(' ')?.join('+')}`}
                                />
                            </Analytics>
                        </Box>
                    </StyledListItem>
                );
            })}
        </StyledList>
    );
}
